module.exports = __webpack_public_path__ + "img/recent-updates.4e6f46a8.svg";